import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()
export class AttendanceService extends ServiceGlobal {
    activity_id: any;
    student_id: any;
    status: any;
    connection: any;
    createddate: any;
    lastmoddate: any;
    group_id: any;
    activity:any;
    student:any;
    api_find_all: any = 'attendance';
    api_find_one: any = 'attendance';
    loading: any = false;
    objectCreate: any[] = [];
    primary_key: any = 'attendance_id';
    tableName() { return 'attendance'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "activity": "attendance_id",
            "student": "student_id",
            "status": "status",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "activity": {
                "type": "any",
                "require": {
                    "empty": true,
                },
            },
            "student": {
                "type": "any",
                "require": {
                    "empty": true,
                },
            },
            "status": {
                "type": "any",
            },
        });
    }
    async insert() {

        let attribute_insert = this.getAttributesInsert();
        if (attribute_insert && Object.keys(attribute_insert).length) {
            return this._db.post(API.CREATE_ATTENDANCES, attribute_insert).then(rs => {
                return Promise.resolve(rs);
            });
        }
    }

    updateAttendance(status: any = 'N/A', activity: any, student: any, attendanceId: any) {
      let attribute_update: any = {
        status: status,
        activity: activity,
        student: student
      };

      let linkUpdateAttendance = API.CREATE_ATTENDANCES + '/' + encodeURIComponent(attendanceId);
      return this._db.put(linkUpdateAttendance, attribute_update);
    }

    updateStatus(connection: any, activity: any, student: any, attendanceId: any) {
        let body: any = {
            connection: connection,
            activity: activity,
            student: student,

        }
        let link = API.CREATE_ATTENDANCES + '/' + encodeURIComponent(attendanceId);
        return this._db.put(link, body);
    }

  async getAttendanceByStudentAndActivity(studentId: any, activityId: any) {
    let link = API.GET_ATTENDANCES + "/?student=" + studentId + "&activity=" + activityId;
    let rs = await this._db.get(link);
    return rs;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/attendance.service.ts